// extracted by mini-css-extract-plugin
export var activeFilterButton = "_og-c";
export var backButton = "_og-4";
export var backIcon = "_og-5";
export var chevronShortcut = "_og-6";
export var container = "_og-1";
export var editor = "_og-8";
export var editorWrapper = "_og-7";
export var prefix = "_og-2";
export var searchIcon = "_og-3";
export var suffix = "_og-9";
export var suffixContent = "_og-a";
export var suffixText = "_og-b";
export var wrapper = "_og-0";